import { createSlice, isAnyOf } from "@reduxjs/toolkit";
import { initialState } from "./initial-state";
import { advanceBatch } from "./thunks/advance-batch";
import { createBatch } from "./thunks/create-batch";
import { distribute } from "./thunks/distribute";
import { getHoldings } from "./thunks/get-holdings";
import { getInventory } from "./thunks/get-inventory";
import { getMovementsSummary } from "./thunks/get-movements-summary";
import { getCustody } from "./thunks/get-custody";
import { getReceptions } from "./thunks/get-receptions";
import { listBatches } from "./thunks/list-batches";
import { receiveBatch } from "./thunks/receive-batch";
import { reconcileBatch } from "./thunks/reconcile-batch";
import { recordCustody } from "./thunks/record-custody";
import { recordReception } from "./thunks/record-reception";

const name = "batches";

const mutations = [
  createBatch,
  advanceBatch,
  receiveBatch,
  reconcileBatch,
  distribute,
  recordReception,
  recordCustody,
];

export const slice = createSlice({
  name,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(listBatches.pending, (state) => {
        state.isPending = true;
        state.isRejected = false;
        state.errorMessage = "";
      })
      .addCase(listBatches.fulfilled, (state, action) => {
        state.list = action.payload;
        state.isPending = false;
        state.isRejected = false;
      })
      .addCase(listBatches.rejected, (state, action) => {
        state.isPending = false;
        state.isRejected = true;
        state.errorMessage = action.error.message ?? "";
      })
      .addCase(getInventory.fulfilled, (state, action) => {
        state.inventory = action.payload;
      })
      .addCase(getMovementsSummary.fulfilled, (state, action) => {
        state.movementsSummary = action.payload;
      })
      .addCase(getHoldings.fulfilled, (state, action) => {
        state.holdings = action.payload;
      })
      .addCase(getReceptions.fulfilled, (state, action) => {
        state.receptions = action.payload;
      })
      .addCase(getCustody.fulfilled, (state, action) => {
        state.portfolios = action.payload;
      })
      .addMatcher(
        isAnyOf(...mutations.map((m) => m.pending)),
        (state) => {
          state.isMutating = true;
          state.mutateError = "";
        },
      )
      .addMatcher(
        isAnyOf(...mutations.map((m) => m.fulfilled)),
        (state) => {
          state.isMutating = false;
        },
      )
      .addMatcher(
        isAnyOf(...mutations.map((m) => m.rejected)),
        (state, action) => {
          state.isMutating = false;
          state.mutateError = action.error.message ?? "";
        },
      );
  },
});

export const actions = slice.actions;
export const reducer = slice.reducer;
